import { useEffect, useState } from "react";
import waterImg from "../../images/IMG_E2940.jpg";
import { getAllBudget } from "../../API/Budget/budgetService";

function AllFinances() {
  const [budgets, setBudgets] = useState<any[]>([]);

  const fetchData = async () => {
    const response = await getAllBudget();
    setBudgets(response?.budgets || []);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
    };
    return date.toLocaleDateString("fr-FR", options);
  };

  const openFile = (budget: any) => {
    const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;
    const fileUrl = `${uploadUrl}/budget/${
      budget.category
    }/${encodeURIComponent(budget.file)}`;
    window.open(fileUrl, "_blank");
  };

  const renderBudgets = (category: string) => {
    return budgets
      .filter((budget) => budget.category === category)
      .map((budget, index) => (
        <button
          key={index}
          onClick={() => openFile(budget)}
          className="transition duration-200 hover:text-blue-800"
        >
          {budget.title} ({formatDate(budget.createdAt)})
        </button>
      ))
      .reduce(
        (prev, curr) => (prev.length === 0 ? [curr] : [...prev, " - ", curr]),
        [] as any
      );
  };

  return (
    <div>
      <section
        className="p-10 text-center lg:p-32 bg-black/70 bg-blend-overlay"
        style={{
          backgroundImage: `url(${waterImg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <h1 className="text-2xl font-bold text-center text-white md:text-4xl lg:text-7xl">
          {"BUDGET"}
        </h1>
      </section>
      <div className="container mx-auto mt-10 mb-10 md:px-40 sm:px-40">
        <p className="text-2xl font-bold text-justify">Documents budgétaires</p>
        <div className="mt-5">
          <div id="administratif">
            <p className="font-bold">
              Compte administratif :{" "}
              <span className="font-normal">
                {renderBudgets("administratifs")}
              </span>
            </p>
          </div>
          <div id="modificative">
            <p className="font-bold">
              Décision modificative :{" "}
              <span className="font-normal">
                {renderBudgets("modificative")}
              </span>
            </p>
          </div>
          <div id="primitif">
            <p className="font-bold">
              Budget primitif :{" "}
              <span className="font-normal">{renderBudgets("primitif")}</span>
            </p>
          </div>
          <div id="budgétaire">
            <p className="font-bold">
              Rapports d'orientation budgétaire :{" "}
              <span className="font-normal">
                {renderBudgets("budgetaires")}
              </span>
            </p>
          </div>
          <div id="supplementaire">
            <p className="font-bold">
              Budget supplémentaire :{" "}
              <span className="font-normal">
                {renderBudgets("supplementaire")}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllFinances;
